import { mapActivityLogs } from 'clients/reports/reportsClient.formatter';
import { mapTaskRiskControls } from 'clients/riskControls/riskControlsClient.formatter';

export const mapTaskData = (data: any) => ({
  ...data,
  activity_logs: data.activity_logs?.map(mapActivityLogs) || [],
  risk_controls: data.risk_controls.map(mapTaskRiskControls) || [],
});
